import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=a1e74a96&scoped=true"
import script from "./baseForm.vue?vue&type=script&lang=js"
export * from "./baseForm.vue?vue&type=script&lang=js"
import style0 from "./baseForm.vue?vue&type=style&index=0&id=a1e74a96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e74a96",
  null
  
)

export default component.exports